import React, { FC } from 'react';
import { Button, Spin } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ResetPasswordFailIcon } from '~/img';
import PasswordResetLayout from '~/layout/PasswordResetLayout';
import { useIdentity } from '~/hooks/identity';
import { auth, pushToLogin } from '~/api/axios';

const NotAuthorized: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('notAuthorized');

  const identityQuery = useIdentity();
  const identityName = identityQuery.data?.name || identityQuery.data?.username || 'Unknown User';

  const onClick = () => {
    auth.deleteToken();
    pushToLogin();
  };

  return identityQuery.isLoading ? (
    <Spin />
  ) : (
    <PasswordResetLayout
      icon={<ResetPasswordFailIcon />}
      title={t('Hello, {{name}}!', { name: identityName })}
      subtitle={t(
        'Sorry, you are not authorized to use this application. Please log out and use another account for login or use another portal.'
      )}
      withGoToLogin
    >
      <Button
        type="primary"
        size="large"
        onClick={onClick}
        loading={identityQuery.isLoading}
        disabled={!identityQuery.data}
      >
        {t('Use another account')}
      </Button>
    </PasswordResetLayout>
  );
};

export default NotAuthorized;
